import { ProgressIndicator } from '@zambezi/sdk/progress-indicator';
import React from 'react';
import './ProgressBar.scss';
import Page from '../Page';

interface ProgressBarProps {
  progressBarPaths: {
    title: string;
    path: string;
  }[];
  selectedIndex: number;
  iconProps?: object;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progressBarPaths,
  selectedIndex,
  iconProps = {}
}) => {
  const pathNames = progressBarPaths.map((item) => item.title);

  return (
    <div className="progress-bar" data-testid="progress-bar">
      <Page>
        <Page.Content fullWidth>
          <ProgressIndicator data={pathNames} selectedIndex={selectedIndex} iconProps={iconProps} />
        </Page.Content>
      </Page>
    </div>
  );
};

export default ProgressBar;
